import { useEffect } from 'react';
import { useDiscipleStore } from '../../../../store/discipleStore';
import { getDisciples } from './apis/disciple-apis';
import { DiscipleInputForm } from './_components/DiscipleInputForm';
import { DiscipleList } from './_components/DiscipleList';
import { Footer } from './_components/Footer';
import styles from './Disciple3000.module.css';

export const Disciple3000 = () => {
  const { setDisciples, disciples } = useDiscipleStore();

  useEffect(() => {
    getDisciples().then(setDisciples);
  }, [setDisciples]);

  return (
    <div className={`col-xs-12 col-sm-12 col-md-12 ${styles.container}`}>
      <DiscipleInputForm />
      <DiscipleList />
      <Footer label="제자" count={disciples.length} unit="명" />
    </div>
  );
};
